<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="课程名称："
        prop="courseName">
        <el-input v-model="info.courseName"></el-input>
      </el-form-item>
      <el-form-item
        label="课程简介："
        prop="courseIntroduction">
        <el-input
          v-model="info.courseIntroduction"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5}"></el-input>
      </el-form-item>
      <el-form-item
        label="培训时间："
        prop="trainingTime">
        <el-input v-model="info.trainingTime"></el-input>
      </el-form-item>
      <el-form-item
        label="报名电话："
        prop="signUp">
        <el-input v-model="info.signUp"></el-input>
      </el-form-item>
      <el-form-item
        label="培训封面："
        prop="topImage">
        <upload-with-crop
          v-model="info.topImage"
          cropper
          :isLt2M="200"
          :fixedNumber="[58,27]"
          :autoCropWidth="290"
          :autoCropHeight="135"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="培训内容："
        prop="detailImages">
        <upload-with-crop
          v-model="info.detailImages"
          :isLt2M="2048"
          :limit="5"
          :autoCropWidth="100"
          :autoCropHeight="100"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="精彩瞬间："
        prop="wonderfulMomentImages">
        <upload-with-crop
          v-model="info.wonderfulMomentImages"
          :isLt2M="2048"
          :limit="5"
          :autoCropWidth="100"
          :autoCropHeight="100"></upload-with-crop>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadWithCrop from '../../components/public/upload-with-crop.vue'
export default {
  name: 'EditServiceModal',
  components: { UploadWithCrop },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        trainingCourseId: null,
        courseName: '',
        courseIntroduction: '',
        trainingTime: '',
        signUp: '',
        topImage: [],
        detailImages: [],
        wonderfulMomentImages: [],
        status: 1
      },
      rules: {
        courseName: [
          { required: true, message: '请输入培训课程名称', trigger: 'blur' },
          { max: 30, message: '培训课程名称长度最多 30 个字符', trigger: 'blur' }
        ],
        courseIntroduction: [
          { required: true, message: '请输入课程简介', trigger: 'blur' },
          { max: 200, message: '课程简介长度最多 200 个字符', trigger: 'blur' }
        ],
        trainingTime: [
          { required: true, message: '请输入培训时间', trigger: 'blur' }
        ],
        signUp: [
          { required: true, message: '请输入报名电话', trigger: 'blur' }
        ],
        topImage: [
          { required: true, message: '请上传鉴定服务封面', trigger: 'blur' }
        ],
        detailImages: [
          { required: true, message: '请上传培训内容', trigger: 'blur' }
        ],
        wonderfulMomentImages: [
          { required: false, message: '请上传精彩瞬间', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const trainingCourseId = this.info.trainingCourseId
      return (trainingCourseId ? '编辑' : '新增') + '培训课程'
    },
    serviceProvinceCode() {
      return this.info.area[0] || null
    },
    serviceCityCode() {
      return this.info.area[1] || null
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        trainingCourseId: null,
        courseName: '',
        courseIntroduction: '',
        trainingTime: '',
        signUp: '',
        topImage: [],
        detailImages: [],
        wonderfulMomentImages: [],
        status: 1
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.trainingCourseId
            ? 'updatetrainingcourse'
            : 'addtrainingcourse'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              topImage: this.info.topImage.map(i => i.url).join(','),
              wonderfulMomentImages: this.info.wonderfulMomentImages.map(i => i.url).join(','),
              detailImages: this.info.detailImages.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
